import { createEntityAdapter } from '@reduxjs/toolkit';
export const objectPhotosAdapter = createEntityAdapter({
    selectId: photo => photo._id,
    sortComparer: (a, b) => Number(a === null || a === void 0 ? void 0 : a.position) - Number(b === null || b === void 0 ? void 0 : b.position),
});
export const objectPhotosAdapterInitState = objectPhotosAdapter.getInitialState();
